import React, { useEffect, useRef, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import {
  extractNumbers,
  getselectedIds,
  isEmptyObject,
  MakeAxiosRequest,
} from "../../../utils/handler";
import { phoneRegex } from "../../../Constants";
import { useDispatch } from "react-redux";
import FormFields from "../../../Components/inputs/FormFields";
import { SwalError, SwalSuccess } from "../../../Components/SwalFns";
import { updateProfile } from "../../../features/authSlice";
import NewRelationship from "./../NewRelationship";
import { InfoModal } from "../../../Components/modals/InfoModal";
import Loader from "../../../Components/loader/Loader";
import UpdateInfoLayout from "./UpdateInfoLayout";

function ContactInformation(props) {
  const {
    showModal,
    closeModal,
    editKey,
    listingFn,
    profileEdit,
    getResponse,
    updateBillingInfo,
    showMoreInfo = false,
    isMaxineStar = false,
    handleBack,
  } = props;
  const methods = useForm();
  const dispatch = useDispatch();
  const { handleSubmit, reset, setValue, watch, trigger, getValues, control, formState: { isDirty, dirtyFields } } = methods;

  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitDisabled, setSubmitDisabled] = useState(false);
  const [showCreateNewRelationship, setShowCreateNewRelationship] = useState(false);
  const [prefillDetails, setPrefillDetails] = useState([]);
  const [optionsList, setOptionsList] = useState({
    relations: [],
    proxyType: [],
    additionalNeed: [],
    states: [],
    responsiblePartyList: [],
    otherRelation: [],
  });
  const [responsibleParty, setResponsibleParty] = useState({});
  const [responsiblePartyPhoneNumberDisabled, setResponsiblePartyPhoneNumberDisabled] = useState(true);

  // const [responsiblePartyOther, setResponsiblePartyOther] = useState({});

  // const submitUrl =  profileEdit ? '/updateprofile' : (editKey ? '/updateproxy' : '/saveproxy');
  const submitUrl = profileEdit
    ? "/updateaditionalcustomerdetails"
    : "/updateaditionalrelationdetails";

  const fetchData = async () => {
    try {
      const statesList = await MakeAxiosRequest("post", "/getstates");
      const createproxyinfo = await MakeAxiosRequest(
        "post",
        "/createproxyinfo"
      );
      if (!profileEdit && editKey) {
        const edit = await MakeAxiosRequest(
          "post",
          "/getaditionalrelationdetails",
          { user_proxy_key: editKey, type: "contact_information" }
        );
        setPrefillDetails({ ...edit.data.relationDetails });
      } else if (profileEdit) {
        const profile = await MakeAxiosRequest("post", "/getaditionalcustomerdetails",{ type: "contact_information" });
        setPrefillDetails({...profile.data.customerDetails});
      }

      const states = statesList.data.state?.map((item) => ({
        // Transform each item as needed
        id: item.id,
        name: item.state_prefix,
      }));

      const infoMessages = createproxyinfo.data.infoMessages;
      setOptionsList({ states, infoMessages });
      setIsLoading(false);
    } catch (error) {
      console.error("Error", error);
    }
  };

  useEffect(() => {
    fetchData();
    setSubmitDisabled(false);
    return () => {
      setSubmitDisabled(false);
      reset();
    };
  }, [showModal]);

  useEffect(() => {
    setSubmitDisabled(false);
    reset({
      responsible_party_label: prefillDetails.responsible_party_label || "",
      responsible_party_id: prefillDetails.responsible_party_id || "",
      responsible_party_type: prefillDetails.responsible_party_type || "",
      responsible_party_phone:
        extractNumbers(prefillDetails.responsible_party_phone) || "",
      responsible_party_country_code:
        prefillDetails.responsible_party_country_code || "",

      address: prefillDetails.address || prefillDetails.addrerss || "",
      city: prefillDetails.city || "",
      state: prefillDetails.state || prefillDetails.state_name || "",
      state_id: prefillDetails.state_id || "",
      service_county: prefillDetails.service_county || "",
      service_county_label: prefillDetails.service_county_label || "",
      postal_code: prefillDetails.postal_code || "",
      zip: prefillDetails.zip || "",
      wallet_permission_enabled:
        prefillDetails.wallet_permission_enabled || "0",
    });
  }, [prefillDetails]);

  const submitData = async (data) => {
    console.log(data);
    // return;
    setSubmitDisabled(true);
    if (updateBillingInfo) {
      updateBillingInfo(data);
    } else {
      try {
        data.state = data.state_id;
        data.responsible_party_phone = extractNumbers(
          data.responsible_party_phone
        );
        const response = await MakeAxiosRequest("post", submitUrl, {
          ...data,
          user_proxy_key: editKey,
          type: "contact_information",
        });
        // console.log(response);
        if (response.status == 1) {
          // getResponse && getResponse(response.data,(profileEdit ? 'profile' : (editKey ? 'update' : 'create')))
          reset();
          handleBack ? handleBack() : closeModal();
          listingFn && listingFn();
          // if(response.data?.msg_key =='subText'){
          //   SwalSuccess({subText: response.data?.message, showbtn:true})
          // }else{
          SwalSuccess({ msg: response.message });
          // }
          // profileEdit && dispatch(updateProfile());
        } else if (response.status == 0) {
          SwalError({ msg: response.message });
        } else {
          // setError('phone_number', { type: 'custom', message: response.message });
          console.log(response.message);
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    }
    setSubmitDisabled(false);
  };

  const handleAddressSelected = (addressComponents) => {
    console.log(addressComponents);
    // Update form fields individually using setValue
    // for (const [key, value] of Object.entries(addressComponents)) {
    //   setValue(key, value);
    //   trigger(key);
    // }
    const stateId =
      optionsList.states.find((state) => state.name === addressComponents.state)
        ?.id || "";

    const fieldMapping = {
      address: "address",
      city: "city",
      state: "state",
      state_id: "state_id",
      county: "service_county_label",
      zip: "zip",
      postal_code: "postal_code",
    };
    // console.log(addressComponents.state,stateId);
    // Map the received address components to form field names
    Object.entries(addressComponents).forEach(([key, value]) => {
      if (fieldMapping[key]) {
        // Use stateId for state field, otherwise use the original value
        const fieldValue = key === "state_id" ? stateId : value;
        setValue(fieldMapping[key], fieldValue);
        trigger(fieldMapping[key]);
      }
    });
  };

  const fetchResponsibleParty = async () => {
    try {
      setOptionsList((preData) => ({ ...preData, responsiblePartyList: [] }));
      const res = await MakeAxiosRequest("post", "/getresponsibleparty", {
        type: profileEdit ? "myprofile" : "relation",
        user_proxy_key: editKey,
        name: watch("first_name"),
      });
      if (res.status == "1") {
        const responsibleParty = res.data.responsible_party?.map((item) => ({
          ...item,
          id:
            item.type === "selectrelation"
              ? "other"
              : item.type === "s"
              ? "self"
              : item.key,
          name: item.text,
          isSelected: item.is_selected,
          optionType: "main",
        }));
        const otherRelation = res.data.other_relation?.map((item) => ({
          ...item,
          id: item.key,
          name: item.nick_name,
          img: item.image_path,
          subtext: item.proxy_relation,
          optionType: "other",
        }));
        const responsiblePartyOptions = [...responsibleParty, ...otherRelation];
        setResponsibleParty(
          responsiblePartyOptions.find((opt) =>
            watch("responsible_party_id")
              ? opt.id === watch("responsible_party_id")
              : opt.isSelected == "1"
          )
        );
        watch("responsible_party_other") ||
          setValue(
            "responsible_party_other",
            responsibleParty.find((item) => item.type === "selectrelation")
              ?.label
          );
        // console.log(responsiblePartyOptions);
        // console.log(watch('responsible_party_label'),getselectedIds(responsibleParty,'isSelected',1));
        setOptionsList((preData) => ({
          ...preData,
          responsiblePartyList: responsiblePartyOptions,
        }));
      } else {
        SwalError({ msg: res.message });
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const fetchStateCounty = async () => {
    try {
      const res = await MakeAxiosRequest("post", "/getstatecounty", {
        state_id: watch("state_id"),
      });
      if (res.status == "1") {
        const county = res.data.countys?.map((item) => ({
          // Transform each item as needed
          id: item.id,
          name: item.county,
        }));
        const countyId =
          res.data.countys.find(
            (cty) => cty.county === watch("service_county_label")
          )?.id || "";

        setValue(
          "service_county",
          getselectedIds(res.data.countys, "is_selected", 1)?.[0] || countyId
        );
        setOptionsList((preData) => ({ ...preData, county }));
      } else {
        SwalError({ msg: res.message });
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  useEffect(() => {
    // console.log("isDirty",isDirty);
    // console.log("dirtyFields",dirtyFields);
    if (watch("state_id")) {
      const state =
        optionsList.states.find((state) => state.id == watch("state_id"))
          ?.name || "";
      setValue("state", state);
      fetchStateCounty();
    }
  }, [watch("state_id")]);

  const fetchCountyByZip = async () => {
    try {
      const res = await MakeAxiosRequest("post", "/getzipcodecounty", {
        zip_code: watch("postal_code") || watch("zip"),
      });
      if (res.status == "1") {
        const county = res.data.countys?.map((item) => ({
          id: item.id,
          name: item.county,
        }));
        setValue("service_county", res.data.county_id);
        setValue("service_county_label", res.data.county_label);
        setOptionsList((preData) => ({ ...preData, county }));
        // }else{
        //   SwalError({msg:res.message})
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  useEffect(() => {
    // console.log('postal_code',watch('postal_code'))
    // console.log('zip',watch('zip'))
    const zip = watch("postal_code") || watch("zip");
    if (zip && /^\d{5}$/.test(zip) && isDirty) fetchCountyByZip();
  }, [watch("postal_code"), watch("zip")]);

  useEffect(() => {
    if (!isEmptyObject(responsibleParty)) {
      setValue("responsible_party_id", responsibleParty.id);
      setValue("responsible_party_type", responsibleParty.type);
      setValue("responsible_party_phone", responsibleParty.phone_number);
      setValue("responsible_party_country_code", responsibleParty.country_code);

      setValue("responsible_party_label", responsibleParty.name);
      if (responsibleParty.optionType === "other") {
        setValue("responsible_party_other", responsibleParty.name);
        setValue("show_responsible_party_other", true);
      } else {
        setValue("responsible_party_other", "");
        setValue("show_responsible_party_other", false);
      }
      setResponsiblePartyPhoneNumberDisabled(
        responsibleParty.is_phone_number_added != 1 ? false : true
      );
    }
  }, [responsibleParty]);

  const fields = [
    {
      name: "responsible_party_label",
      label: "Contact Person",
      className: "col-md-6 mb-3",
      // rules: { required: "Please select user" },
      type: "popupselectother",
      info: (
        <InfoModal
          {...optionsList.infoMessages?.find(
            (itm) => itm.type === "contact_person"
          )}
        />
      ),
      onOpen: fetchResponsibleParty,
      // onClose: ()=>setOptionsList((preData) => ({ ...preData, responsibleParty: [] })),
      options: optionsList.responsiblePartyList,
      hasData: optionsList.responsiblePartyList?.length > 0,
      selectedOptionObj: responsibleParty,
      selectFunction: (opt) => {
        // console.log(opt);
        // setValue('show_responsible_party_other', opt.type=='selectrelation' ? '1' : '0');
        // setValue('responsible_party_type', opt.type);
        // setResponsibleParty(opt);
      },
      onConfirm: (opt) => {
        // console.log(opt);
        setResponsibleParty(opt);
      },
      createBtn: {
        name: "Create New Relationship",
        icon: "group_add",
        onClick: () => setShowCreateNewRelationship(true),
      },
      isShow: true,
    },
    {
      name: "responsible_party_phone",
      countryCodeName: "responsible_party_country_code",
      label: `${
        watch("responsible_party_label") != ""
          ? `${
              watch("responsible_party_label")?.charAt(0).toUpperCase() +
              watch("responsible_party_label")?.slice(1)
            }'s`
          : "Contact Person"
      }  Phone Number`,
      className: "col-md-6 mb-3",
      rules: {
        required: "Please enter phone number",
        pattern: {
          value: phoneRegex,
          message: "Please enter a valid phone number",
        },
        // validate: (value) => {
        //   console.log(value);
        //   console.log(phoneRegex.test(value));
        //   return phoneRegex.test(value) || "Please enter a valid phone number";
        // },
        //   ...(!editKey && !profileEdit && {
        //   validate: {
        //     existCheck: async (fieldValue) => {
        //       const response = await MakeAxiosRequest("post","/searchproxybyphone",{ phone_number: extractNumbers(fieldValue), country_code: getValues('country_code') });
        //       return response?.status == 1 || response?.message;
        //     },
        //   },
        // }),
      },
      isdisabled: !!responsiblePartyPhoneNumberDisabled,
      mask: "(999) 999-9999",
      type: "phonenumberfield",
      // isShow: responsibleParty?.type==='r',
      isShow:
        watch("responsible_party_type") === "r" ||
        watch("responsible_party_type") === "s",
    },
    {
      text: "Service Address",
      type: "title",
      showUnderline: true,
      isShow: true,
    },
    {
      name: "address",
      label: "Address",
      className: "col-12 mb-3",
      rules: {
        // required: "Please enter address",
        maxLength: {
          value: 250,
          message: "Maximum 250 characters allowed",
        },
      },
      // type: "textarea",
      type: "addressautocomplete",
      onAddressChange: handleAddressSelected,
      isShow: true,
    },
    {
      name: "city",
      label: "City",
      className: "col-md-6 mb-3",
      // rules: { required: "Please enter city" },
      type: "inputfield",
      isShow: true,
    },
    {
      name: "state",
      label: "State",
      className: "col-md-6 mb-3",
      // rules: { required: "Please select state" },
      // type: "select",
      type: "popupselect",
      showSearch: true,
      onConfirm: (opt) => {
        setValue("state_id", opt.id);
        setValue("state", opt.name);
      },
      selectedOptionObj:
        optionsList.states?.find((itm) => itm.id === watch("state_id")) || {},
      options: optionsList.states,
      isShow: true,
    },
    {
      // name: profileEdit ? "zip" : "postal_code",
      name: "postal_code",
      label: "Zip",
      className: "col-md-6 mb-3",
      rules: {
        // required: "Please enter zip",
        pattern: {
          value: /^\d{5}$/,
          message: "Please enter a valid zip",
        },
      },
      type: "inputfield",
      isShow: true,
    },
    {
      name: "service_county_label",
      label: "County ",
      className: "col-md-6 mb-3",
      // rules: { required: "Please select state" },
      // type: "select",
      type: "popupselect",
      showSearch: true,
      onConfirm: (opt) => {
        setValue("service_county", opt.id);
        setValue("service_county_label", opt.name);
      },
      selectedOptionObj:
        optionsList.county?.find((itm) => itm.id === watch("service_county")) ||
        {},
      options: optionsList.county,
      isShow: true,
    },
  ];

  if (isLoading) return <Loader />;
  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submitData)}>
          <UpdateInfoLayout
            title="Contact Information"
            handleBack={handleBack}
            isSubmitDisabled={isSubmitDisabled}
          >
            <FormFields fields={fields} />
          </UpdateInfoLayout>
        </form>
      </FormProvider>
      {showCreateNewRelationship && (
        <NewRelationship
          showModal={showCreateNewRelationship}
          closeModal={() => setShowCreateNewRelationship(false)}
          listingFn={(res) => {
            setResponsibleParty(res);
            setOptionsList((preData) => ({
              ...preData,
              responsiblePartyList: [],
            }));

            // fetchResponsibleParty();
          }}
        />
      )}
    </>
  );
}

export default ContactInformation;
